<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <luma-empty >

      <div v-if="!next">
        <!--PAKETE-->
        <div class="text-center ">
          <div v-if="key !== 'custom' && !customize "
               class="inline m-4"
               v-for="(item, key) in products"
               :key="key">
            <luma-create-vserver :productName="item.product_name"
                                 :productKey="item.product_key"
                                 :prices="pricesPerHour[item.product_key] || null"
                                 :selected="true"
                                 :apiPrices="apiPrices"
                                 class="mb-2">
            </luma-create-vserver>

            <b-btn v-if="!shoppingCheck || !shoppingCheck[item.product_key]"
                   variant="outline-primary"
                   class="col-12"
                   @click="selectedProduct(item.product_key)">
              Zur Bestellung hinzufügen
            </b-btn>

            <b-row>
              <b-col>
                <b-button
                  v-if="shoppingCheck && shoppingCheck[item.product_key]"
                  @click=" shoppingCardC[shoppingCheck[item.product_key].index].amount += 1, updateModel(shoppingCheck[item.product_key].index, item.product_key) "
                  :disabled="productAmount > 49"
                  variant="outline-success" >
                  <i class="fa fa-plus"></i>
                  Hinzufügen
                  <h2>{{shoppingCardC[shoppingCheck[item.product_key].index].amount}}</h2>
                </b-button>
              </b-col>
              <b-col>
                <b-row>
                  <b-button
                    v-if="shoppingCheck && shoppingCheck[item.product_key]"
                    @click="  shoppingCardC[shoppingCheck[item.product_key].index].amount > 1 ? shoppingCardC[shoppingCheck[item.product_key].index].amount -= 1 : '', updateModel(shoppingCheck[item.product_key].index, item.product_key) "
                    class="col-10 m-1"
                    variant="" >
                    <i class="fa fa-minus"></i>
                    Weniger
                  </b-button>
                </b-row>
                <b-row>
                  <b-button
                    v-if="shoppingCheck && shoppingCheck[item.product_key]"
                    @click=" deleteProduct(item.product_key)"
                    class="col-10 m-1"
                    variant="" >
                    <i class="fa fa-close"></i>
                    Entfernen
                  </b-button>

                </b-row>
              </b-col>
            </b-row>

          </div>

          <div v-if="key === 'custom' && customize "
               v-for="(item, key) in products"
               :key="key+1"
               class="inline m-4">

            <luma-create-vserver  :productName="item.product_name"
                                  :productKey="item.product_key"
                                  class="mb-2"
                                  :prices="pricesPerHour[item.product_key] || null"
                                  :selected="true">
            </luma-create-vserver>

            <b-btn v-if="!shoppingCheck || !shoppingCheck[item.product_key]"
                   variant="outline-primary"
                   class="col-12"
                   @click="selectedProduct(item.product_key)">
              Zur Bestellung hinzufügen
            </b-btn>

            <b-row>
              <b-col>
                <b-button
                  v-if="shoppingCheck && shoppingCheck[item.product_key]"
                  @click=" shoppingCardC[shoppingCheck[item.product_key].index].amount += 1, updateModel(shoppingCheck[item.product_key].index, item.product_key) "
                  :disabled="productAmount > 49"
                  variant="outline-success" >
                  <i class="fa fa-plus"></i>
                  Noch eins...
                  <h2>{{shoppingCardC[shoppingCheck[item.product_key].index].amount}}</h2>
                </b-button>
              </b-col>
              <b-col>
                <b-row >

                  <b-button
                    v-if="shoppingCheck && shoppingCheck[item.product_key]"
                    @click="  shoppingCardC[shoppingCheck[item.product_key].index].amount > 1 ? shoppingCardC[shoppingCheck[item.product_key].index].amount -= 1 : '', updateModel(shoppingCheck[item.product_key].index, item.product_key)  "
                    class="col-10 m-1"
                    variant="" >
                    <i class="fa fa-minus"></i>
                    Weniger
                  </b-button>
                </b-row>

                <b-row>
                  <b-button
                    v-if="shoppingCheck && shoppingCheck[item.product_key]"
                    @click=" deleteProduct(item.product_key)"
                    class="col-10 m-1"
                    variant="" >
                    <i class="fa fa-close"></i>
                    Entfernen
                  </b-button>

                </b-row>
              </b-col>
            </b-row>

          </div>
        </div>


        <b-container class="text-center">

          <b-button  class="col-12 m-2"
                     style="max-width: 940px"
                     variant="outline-primary"
                     @click="customize = !customize">
            {{!customize ? 'Selbst Konfigurieren' : 'Pakete Anzeigen' }}
          </b-button>

        </b-container >
        <hr>


        <!--PAKETE ENDE-->
      </div>

    <b-container class="text-center">

      <b-button  class="col-12 m-2"
                 style="max-width: 940px"

                 variant="primary"
                 @click="next = !next">
        {{!next ? 'Weiter' : 'Zurück' }}
      </b-button>

    </b-container >

    <div v-if="next">
      <!--BESTELLUNG WEITER -->

      <b-container  v-if="!orderStatus" style="max-width: 800px" class="text-center" >
      <h1>Betriebssytem wählen</h1>
      <luma-os-selection-vserver class="mt-4"></luma-os-selection-vserver>
      </b-container>

      <b-container class="text-center center" v-if="!orderResult">
        <div style="max-width: 800px"  class="center p-3" >
          <h1>Bestellung</h1>

          <b-card class="center mt-4" >
            <div v-if="shoppingCardC" class="center">
              <table class="center">
                <th class="spacing">Produkt</th>
                <th class="spacing">Anzahl</th>
                <th class="spacing">Betriebsystem</th>
                <th class="spacing">Preis: €/Monat</th>
                <th class="spacing">Entfernen</th>
                <th class="spacing">Gruppe</th>
                <th class="spacing">Vserver Details</th>
                <tr v-for="(item, key) in shoppingCardC"
                    :key="key+2"

                    style="width: 220px;">
                  <td class="spacing">
                    {{item.product_name}}
                  </td>
                  <td class="spacing">
                    <b-form-input type="number"
                                  min="1"
                                  max="50"
                                  :disabled="productAmount > 49"
                                  class="amount"
                                  @input="updateModel(key, shoppingCardC[key].product_key )"
                                  v-model="shoppingCardC[key].amount">
                    </b-form-input>
                  </td>
                  <td  class="spacing">
                    {{item.vserver_template}}
                  </td>
                  <td class="spacing">
                    <b>{{ Number((item.price * item.amount).toFixed(1)) }} €</b>
                  </td>
                  <td class="spacing">
                    <b-link class="m-4"  @click="deleteProduct(item.product_key)">
                      <i class="fa fa-close"></i>
                    </b-link>
                  </td>
                  <td class="spacing">
                    <b-form-input type="text"
                                  style="width: 90px"
                                  @input="updateModel(key, shoppingCardC[key].product_key )"
                                  v-model="shoppingCardC[key].hostname_group">
                    </b-form-input>
                  </td>
                  <td class="spacing" v-if="productDetailList">
                    <b-link @click="$bvModal.show(shoppingCardC[key].product_key+3)">Show</b-link>
                    <b-modal :id="shoppingCardC[key].product_key+3">
                      <template v-slot:modal-footer>
                        <h2 class="m-2"><i class="fa fa-info m-2"></i> </h2>
                        Vserver Namen eintragen oder frei lassen für automatische Namensvergabe.
                      </template>
                      <luma-order-modal-list-vserver  :productName="shoppingCardC[key].product_name"
                                                      :productKey="shoppingCardC[key].product_key"></luma-order-modal-list-vserver>
                    </b-modal>

                  </td>
                </tr>
              </table>
            </div>
          </b-card>
        </div>
      </b-container>
      <!--BESTELLUNG ENDE-->
    </div>
    <b-container class="text-center" v-if="!orderResult">
      <luma-order-vserver v-if="next" ></luma-order-vserver>
    </b-container>
    <b-container class="text-center" v-if="orderResult">
      <luma-order-result v-if="next"></luma-order-result>
    </b-container>
    <b-container class="text-center">
      <luma-order-response v-if="next"></luma-order-response>
    </b-container>

    <div  class="fixed-bottom footer-summary">

      <b-row v-if="prices ">
        <b-col md="4">
          <h3>Preis:</h3>
          <h2><b>{{ formatPrice(priceSum !== 'NaN' ? priceSum : 0) }} €</b> / Monat ({{ formatPrice((priceSum !== 'NaN' ? priceSum : 0) / 720, 3) }} € / Stunde)</h2>
        </b-col>
        <b-col md="4" offset-md="4">
          <button class="btn btn-primary pull-right btn-xl btn-create"
                  v-if="next && !orderStatus"
                  @click="checkOrderStatus()">
            Jetzt erstellen
          </button>
          <button class="btn btn-primary pull-right btn-xl btn-create"
                  v-if="next && orderStatus"
                  @click=" next = false , orderStatus = false, refresh() ">
            zu den Produkten
          </button>
        </b-col>
      </b-row>
    </div>

    <div style="height: 200px;"></div>
    <div v-if="!redirectIfOneOrder"></div>
  </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty"
    import LumaCreateVserver from "@/components/datacenter/vserver_datacenter/luma-create-vserver";
    import LumaOrderVserver from "@/components/datacenter/vserver_datacenter/luma-order-vserver";
    import LumaOsSelectionVserver from "@/components/datacenter/vserver_datacenter/luma-os-selection-vserver";
    import LumaOrderResponse from "@/components/datacenter/vserver_datacenter/luma-order-response";
    import LumaOrderModalListVserver from "@/components/datacenter/vserver_datacenter/luma-order-modal-list-vserver";
    import LumaOrderResult from "@/components/datacenter/vserver_datacenter/luma-order-result";

    import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";
    import {VserverProducts} from "@/mixins/vserver_products";
    import {VserverOrder} from "@/store/models/vserver/vserver_order";
    import {VserverPrices} from "@/store/models/vserver/vserver_prices";

    import {VserverOrderErrorList} from "@/store/models/vserver/vserver_order_error_list";
    import {VserverOrderResults} from "@/store/models/vserver/vserver_order_results";
    import formatPriceMixin from "@/mixins/formatPriceMixin";

    export default {
        name: "datacenter-vserver-create",

        mixins:[VserverProducts, formatPriceMixin],
        data: () => ({
            orderStatus:false,
            next : false,
            pricesM:{},
            customize:false,
            shoppingCard:null,
            titles: [
                {
                    hostname: 'new-virtual-server',
                    title: null
                }
            ],
            packageName: null,
            config: null,
            templateKey: null,
            distribution: null
        }),
        components: {
            LumaOrderResult,
          LumaOrderModalListVserver,
          LumaOrderResponse,
            LumaOsSelectionVserver,
            LumaOrderVserver,
            LumaCreateVserver,
            LumaEmpty
        },
        created(){
          VserverPrices.pricingVservers()
        },

        computed: {
          redirectIfOneOrder(){
              if(!this.orderResult) return
              if(this.orderResult.length > 1) return
              if(this.orderResult.length === 1 && VserverOrderList.all().length === 1) {
                  const x = this.orderResult[0].id
                  VserverOrderResults.deleteAll()
                  this.$router.push({ name: 'vservers-single', params: { id: x } })
                  return
              }
          },
          apiPrices(){
            //VserverPrices.priceCalculator(VserverPrices.all()[0])
            const x = {}
            const y = VserverPrices.all().map(el=>{
              x[el.unit] = el
            })
            return x
          },
        customPrice(){
          if(!VserverOrder.all().length) return

          const ll = VserverOrder.all().map(el=>{
            if( VserverOrder.find(el.product_key) ) {
              const x = VserverOrder.find(el.product_key)
              const z = ( ((x.cores - this.apiPrices.cores.free_units) / this.apiPrices['cores'].step  * this.apiPrices.cores.price) +
                          ((x.memory - this.apiPrices.memory.free_units)/this.apiPrices['memory'].step * this.apiPrices.memory.price) +
                          ((x.disk - this.apiPrices.disk.free_units)/this.apiPrices['disk'].step * this.apiPrices.disk.price) +
                          ((x.backups - this.apiPrices.backups.free_units)/this.apiPrices['backups'].step * this.apiPrices.backups.price ) +
                          ((x.addresses_v4 - this.apiPrices.addresses_v4.free_units)/this.apiPrices['addresses_v4'].step * this.apiPrices.addresses_v4.price ))
              VserverOrder.update( {where:el.product_key,data:{price:z}} )
              }
            })
          return VserverOrder.all().map(el=>el.price)
        },

        prices(){
            if(!this.shoppingCardC) return
            this.customPrice
            return this.shoppingCardC.map( el=>el.price*el.amount )
            //return this.shoppingCardC.map(el=>el.productKey !== 'custom' ? el.price*el.amount : 0)
          },
        pricesPerHour(){
            if(!this.shoppingCardC) return
            const x = {}
            this.shoppingCardC.map( el=>{
                x[el.product_key]= {
                    single: Number(el.price/720).toFixed(3),
                    all:Number(el.price*el.amount/720).toFixed(3)
                }
            } )
            return x
            //return this.shoppingCardC.map(el=>el.productKey !== 'custom' ? el.price*el.amount : 0)
        },
        priceSum(){
          if(!this.prices) return
          return Number(this.prices.reduce((sum, x) => sum + x)).toFixed(1)
        },
          products(){
            const x = Object.assign({},VserverProducts)
            return x
          },
          shoppingCardC(){
          if(!VserverOrder.all().length) return [VserverProducts['starter']]
            const x = JSON.parse(JSON.stringify(VserverOrder.all()))
            this.shoppingCard = x
            return this.shoppingCard
          },
          shoppingCheck(){
              if(!VserverOrder.all().length) return
              const y = {}
              const x = VserverOrder.all().map((el,index)=>{
                  y[el.product_key]= {
                      amount:el.amount,
                      index:index
                  }
              })
              return y
          },
          productAmount(){
            let amount = 0
            const x = VserverOrder.all().map(el=>{amount +=el.amount})
            return amount
          },
          productDetailList(){
            if(VserverOrderList.all().length !== this.productAmount){
              //VserverOrderList.deleteAll()
              const x = Object.keys(this.shoppingCheck).map(el=>{
                const y = VserverOrder.find(el).amount
                const arr = Array.from(Array(y).keys())
                .map((item,index)=>{
                  if(VserverOrderList.find(el+'-v-'+index)){
                      this.updateInstance(el+'-v-'+index , el)
                  }
                  if(!VserverOrderList.find(el+'-v-'+item)){
                      this.createInstanz(el,index)
                    }
                })
              })
            }
            const xxx = VserverOrderList.all().map((el)=>(el))
            return xxx
        },
        orderResult(){
              if(!VserverOrderResults.all().length) return
              if(VserverOrderResults.all().length && VserverOrderResults.all().length === VserverOrderList.all().length ) {
                  this.orderStatus = true
              }
              return VserverOrderResults.all()
          }
        },
        methods: {
            refresh(){
                VserverOrderResults.deleteAll()
                VserverOrderList.deleteAll()
                VserverOrder.deleteAll()
            },
            updateInstance(product_key,product){
                const x = JSON.parse(JSON.stringify(VserverOrder.find(product)))
                //const x = Object.assign({},VserverOrder.find(product))
                x.product_key = product_key
                x.$id = product_key
                VserverOrderList.insertOrUpdate({data: x})
                return
            },
            createInstanz(product_key,index){
                const x = JSON.parse(JSON.stringify(VserverOrder.find(product_key)))
                const newKey = index ? product_key + '-v-'+ index : product_key + '-v-'+ '0'
                x.product_key = newKey
                const y = VserverOrderList.insertOrUpdate({data:x})
              return
            },

            deleteInstanz(productKey,index){
              const key = productKey +'-v-'+ index
              VserverOrderList.delete(key)
              return
            },

            updateModel(index,key){
              if(!VserverOrder.find(key)) return
              const x = JSON.parse(JSON.stringify(this.shoppingCardC[index]))
              VserverOrder.update({where:key,data:x})
              return
            },

             selectedProduct(key){
               console.log('SELECTED :::dd:',key)
              if(VserverOrder.find(key)) return
              if(!VserverOrder.find(key)) VserverOrder.insertOrUpdate({data:this.products[key]})
               this.createInstanz(key,0)
              return
            },

            deleteProduct(key){
              console.log('deleteProduct:::',key)
              if(VserverOrder.find(key)) VserverOrder.delete(key)
              VserverOrderList.deleteAll()
              return
            },

            async sendOrder() {
              if( VserverOrderErrorList.all().length )  VserverOrderErrorList.deleteAll()
              if( VserverOrderResults.all().length ) VserverOrderResults.deleteAll()

              let res
              const x = this.productDetailList.map((el,index)=>{
                //this.productDetailList[index].status = 'pending'
                VserverOrderList.update({where:el.product_key,data:{status:'pending'}})
                console.log('ORDERIN ::::',el)
                res = VserverOrder.sendOrder(el)
                    .then(response=>{
                        console.log('RESPONSEEE::',response)
                        VserverOrderList.insertOrUpdate({
                            where:el.product_key,data:{
                                status:response.status,
                                id:response.data.vserver.id
                            }})
                        VserverOrderResults.insertOrUpdate({data:VserverOrderList.find(el.product_key)})
                        if(response.status === 'error') {
                            const xx = Object.assign({},this.productDetailList[index])
                            VserverOrderErrorList.insertOrUpdate({data:xx})
                        }
                      this.$router.push({name:'datacenter-vserver'})
                    })
                    .catch(err=> {
                        VserverOrderList.update({where:el.product_key,data:{status:err.status}})
                        //this.productDetailList[index].status = err.status
                        if(err.status === 'error') VserverOrderErrorList.insertOrUpdate({data:this.productDetailList[index]})
                    })
              })
            },
            checkOrderStatus(){
                //if(!this.productDetailList.length) return
                if(this.priceSum === 'NaN') return
                //if(VserverOrderErrorList.all().length) return
                if(!VserverOrderList.all().length) return
                const x = this.sendOrder()
            }
        }
    }
</script>

<style scoped>
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
  .btn-create {
    height: 50px;
    line-height: 30px;
    width: 200px;
    font-size: 17px;
    color: white !important;
    margin-top: 16px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .spacing{
    margin-right: auto;
    margin-left: auto;
    width: 58px;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 22px;
    justify-content: center;
    vertical-align: auto;
  }
  .amount{
    visibility: visible;
    background: none;
    border-top: none;
    border-left: none;
    border-right-width: 8px;
    border-bottom-width: 1px;
    border-bottom:none;
    width: 74px;
    padding: 8px;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    opacity: 1;
  }
  .center{
    padding-right: auto;
    padding-left: auto;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/datacenter-vserver-create.vue